import React, { useState } from "react";
import { PropTypes } from "prop-types";
import { Modal, Button, Form, FormControl } from "react-bootstrap";

function ModalAddFile(props) {
  const initialForm = {
    uploadfile: null,
    desc: "",
  };
  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({});

  const handleClose = () => {
    setErrors({});
    setForm({});
    props.hidden_func(false);
  };
  const setField = (field, value) => {
    // console.log(field.files);
    if (field.files) {
      setForm({
        ...form,
        [field.name]: field.files[0],
      });
      setErrors({
        ...errors,
        [field.name]: null,
      });
    } else {
      setForm({
        ...form,
        [field.name]: value,
      });
      setErrors({
        ...errors,
        [field.name]: null,
      });
    }
  };

  const findFormErrors = () => {
    const { desc, uploadfile } = form;
    const newErrors = {};
    if (!desc || desc === "") newErrors.desc = "กรุณาระบุคำอธิบาย";
    if (!uploadfile) newErrors.uploadfile = "กรุณาเลือกไฟล์";
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      const newform = new FormData();
      for (const key in form) {
        newform.append(key, form[key]);
      }
      props.func_sub(newform);
    }
  };
  return (
    <div>
      <Modal show={props.show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>เพิ่มไฟล์สำหรับดาวน์โหลด</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="disabledTextInput">
                เลือกไฟล์ที่ต้องการอัพโหลด
              </Form.Label>
              <Form.Control
                id="disabledTextInput"
                placeholder="เลือกไฟล์ที่ต้องการอัพโหลด"
                type="file"
                onChange={(e) => setField(e.target, e.target.value)}
                name="uploadfile"
                isInvalid={!!errors.uploadfile}
              />
              <Form.Control.Feedback type="invalid">
                {errors.uploadfile}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="disabledSelect">
                คำอธิบายไฟล์ข้อมูล
              </Form.Label>
              <FormControl
                placeholder="คำอธิบายไฟล์ข้อมูล"
                type="text"
                name="desc"
                value={form.desc}
                onChange={(e) => setField(e.target, e.target.value)}
                isInvalid={!!errors.desc}
              />
              <Form.Control.Feedback type="invalid">
                {errors.desc}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ModalAddFile;
ModalAddFile.propTypes = {
  show: PropTypes.bool,
  hidden_func: PropTypes.func,
  func_sub: PropTypes.func,
};
